import { IFiltrosHistorial, IPerfil } from '../../../dto/ContractDTO'
import { ITenant } from '../../AbmLocalPage/types'
import { FiltrosFac } from '../Facturacion/FiltrosFacturacion'
import { axiosInstanceContratos } from '../../../utils/axiosGlobalUtils'

export const getRenovables = async (tenant: ITenant) =>
  await axiosInstanceContratos.get(`/contratos/${tenant.path}/renovables`)

export const getLinkPago = async (idContrato: number, platform: string) =>
  await axiosInstanceContratos.post(`/contratos/${idContrato}/links-de-pago`, {
    platform: platform,
    source: 'whatsapp'
  })

export const getHistorial = async ({ idContratoProducto, fechaDesde, fechaHasta, size, page }: IFiltrosHistorial) => {
  const params = new URLSearchParams({
    size: String(size),
    page: String(page),
    ...(idContratoProducto && {
      idContratoProducto: idContratoProducto.toString()
    }),
    ...(fechaDesde && { fechaDesde }),
    ...(fechaHasta && { fechaHasta })
  })

  const url = `/contratos/historial?${params.toString()}`
  return await axiosInstanceContratos.get(url)
}

export const getMediosPago = async () => await axiosInstanceContratos.get(`/contratos/medios-de-pagos?size=10&page=0`)

export const getPerfilImp = async (codLocal: string) =>
  await axiosInstanceContratos.get(`/contratos/locales/${codLocal}/perfil-impositivo`)

export const actualizarPerfil = async (codLocal: string, data: IPerfil) =>
  await axiosInstanceContratos.put(`/contratos/locales/${codLocal}`, data)

export const getPadron = async (cuit: string) =>
  await axiosInstanceContratos.get(`/contratos/consulta-padron?cuit=${cuit}`)

export const getEstadosFacturacion = async () => await axiosInstanceContratos.get('/contratos/facturacion/jobs/estados')

export const getJobs = async (filtros: FiltrosFac, page: number, size: number, orden: { key: string; dir: string }) => {
  const params = new URLSearchParams({
    page: String(page),
    size: String(size)
  })

  if (orden) {
    params.append('sortBy', orden.key)
    params.append('sortDir', orden.dir)
  }

  filtros.estado && params.append('estado', String(filtros.estado))
  filtros.idFacturacionJob && params.append('idFacturacionJob', String(filtros.idFacturacionJob))
  filtros.idContratoCtaCte && params.append('idContratoCtaCte', String(filtros.idContratoCtaCte))
  filtros.transactionId && params.append('transactionId', String(filtros.transactionId))
  filtros.numeroDocumento && params.append('numeroDocumento', String(filtros.numeroDocumento))
  filtros.cae && params.append('cae', String(filtros.cae))

  return axiosInstanceContratos.get(`/contratos/facturacion/jobs?${params.toString()}`)
}

export const getPerfilIncompleto = async (page: number, size: number) =>
  await axiosInstanceContratos.get(`/contratos/locales/perfil-impositivo-incompleto?page=${page}&size=${size}`)

export const consumidorFinalJob = async (idJob: number) =>
  await axiosInstanceContratos.put(
    '/facturacion/jobs/consumidor-final',
    { idsFacturacionJob: [idJob], forzar: true },
    {
      headers: {
        Authorization: `Bearer eyJhbGciOiJIUzUxMiJ9.eyJwZXJtaXNvcyI6ImFkbWluIiwic3ViIjoiMjQ1OTIiLCJleHAiOjE3ODUyNTU3NDYsImlhdCI6MTc4NTE2OTM0Nn0.engeyrdzMvBKOkl9fh84bBqXighJm9uVQcJwGWM5ndaO4_j4-r9OZG44T_UV1agPM74Y-DvaSOjHeYya_Dxi4w`,
        'Content-Type': 'application/json'
      }
    }
  )
